<template>
    <div>
        <b-modal id="add-system-user-popup" ref="modal" :title="titleHeading" size="lg" no-close-on-backdrop hide-footer
            modal-class="hide-footer" no-close-on-esc @hidden="onHidden">
            <b-form @submit.stop.prevent="onSubmit()" @reset.stop.prevent="onHidden">

                <div class="row">
                    <div class="col-sm-12">
                        <label class="form-control-label">First Name</label>
                        <base-input placeholder="Enter Name" v-model="formData.firstName"></base-input>
                    </div>
                    <div class="col-sm-12">
                        <label class="form-control-label">Last Name</label>
                        <base-input placeholder="Enter Name" v-model="formData.lastName"></base-input>
                    </div>
                    <div class="col-sm-12">
                        <label class="form-control-label">Email</label>
                        <base-input placeholder="Enter Email" v-model="formData.email"></base-input>
                    </div>
                    <div class="col-sm-12">
                        <label class="form-control-label">Phone Number</label>
                        <base-input placeholder="Enter Number" v-model="formData.phoneNumber"></base-input>
                    </div>
                    <div class="col-sm-12">
                        <label class="form-control-label">Role</label>
                        <b-form-select name="role" v-validate="{ required: true }" v-model="formData.roleId"
                            :options="roleOptions"></b-form-select>
                    </div>

                    <div class="col-md-12 action-buttons mt-5">
                        <base-button @click="onSubmit()" btn-variant="primary" :class="loading ? 'disabled' : ''"
                            :loading="loading">{{ buttonLabel }}</base-button>
                        <!--<base-button-->
                        <!--btn-type="reset"-->
                        <!--btn-variant="link"-->
                        <!--&gt;Cancel</base-button>-->
                    </div>

                </div>

            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from "../../util/request";
import resource from '../../api/resource'
const roles = new resource('system-users/roles')

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['show'],
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        titleHeading() {
            return this.selectedItem
                ? 'Modify System User'
                : 'Add System User'
        }, // End of title() method
        isDisabled() {
            return this.selectedItem
                ? true
                : false
        }, // End of title() method
        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            apiUrl: process.env.VUE_APP_API_URL,
            statusOptions: [
                { value: 'Active', text: 'Active' },
                { value: 'Inactive', text: 'Inactive' },
            ],
            formData: this.initializeFormData(),
            roleOptions: [],
            // loading:false
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    },
    mounted() {
        this.getRolesList();
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                roleId: '',
                status: 'active'
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            try {
                // update configuration
                this.$store.commit('setLoading', true);

                const response = await request.post('/system-users/', {
                    data: this.formData,
                });

                console.log(response);
                this.$toasted.show(response.data.message, {
                    type: 'success',
                });
                this.$store.commit('setLoading', false);
                this.$emit('child-event');
                this.onHidden();
            } catch (error) {
                this.$toasted.show("Something went wrong, try again later!", {
                    type: 'error',
                });
                console.log("Error:", error);
                this.$store.commit('setLoading', false);
            }
        },
        // End of onSubmit() method

        async getRolesList() {

            const result = await roles.list();
            if (result && result.data) {
                let tempRoles = result.data.data.map(el => ({ value: el.id, text: el.title }));
                tempRoles = [{ value: '', text: 'Please select role' }, ...tempRoles]
                this.roleOptions = tempRoles;
            }

        },

    }, // End of Component > watch
}
</script>
